import React, { Component, createRef } from 'react'
import PropTypes from 'prop-types'
import { Layout, NavDrawer } from 'react-toolbox/lib/layout'
import CSSModules from 'helpers/CSSModulesUtil'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import Panel from './Panel'

import Specifications from 'containers/Project/Specifications/index'
import Card from './Card'
import ActionBar from './ActionBar'

import {
  formattedCategoriesSelector,
} from 'containers/Project/OverviewSidebar/selectors'
import {
  brandSelector,
  productGpuSkuSelector,
  productSkuSelector,
  partnerSiteNameSelector,
  projectIdSelector,
  segmentSelector,
  scrolledTop
} from 'containers/Project/View/selectors'
import { collapsingSelector } from 'containers/Project/Header/selectors'
import {
  scrollTop
} from 'containers/Project/View/actions'
import {
  riskSelector,
} from 'containers/Form/RiskValidation/selectors'
import { collapseSelector } from 'containers/Project/Header/selectors'
import { setSticky } from 'containers/Project/Header/actions'

import EditHeader from 'containers/Project/Header/EditHeader'

import styles from './styles.scss'

const mapStateToProps = (state) => {
  return {
    projectId: projectIdSelector(state),
    gpuSku: productGpuSkuSelector(state),
    productBrand: brandSelector(state),
    partnerSite: partnerSiteNameSelector(state),
    productSku: productSkuSelector(state),
    segment: segmentSelector(state),
    categories: formattedCategoriesSelector(state),
    isRisk: riskSelector(state),
    restricted: state.uiState.project.restricted,
    scrolledTop: scrolledTop(state),
    collapsing: collapsingSelector(state),
    collapse: collapseSelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    scrollTopAction: (isTop) => dispatch(scrollTop(isTop)),
    setSticky: (sticky) => dispatch(setSticky(sticky))
  }
}

class ReviewLayout extends Component {

  constructor(props) {
    super(props);
    this.scrollDivRef = createRef();
  }

  onScroll = (e) => {
    const {
      scrolledTop,
      scrollTopAction,
      collapse,
      setSticky,
    } = this.props
    const top = Math.floor(e.target.scrollTop) < this.scrollDivRef.current.offsetTop

    if (top === scrolledTop) return
    if (collapse !== top) setSticky(collapse)
    scrollTopAction(top)  
  }

  render() {

    const {
      id,
      redirect,
      projectId,
      productSku,
      productBrand,
      gpuSku,
      segment,
      partnerSite,
      isRisk,
      restricted,
      onSubmit,
      setFormStatus
    } = this.props
  return (
    <Layout
      theme={styles}
      onScroll={this.onScroll}
    >
      <NavDrawer
        pinned
        theme={styles}>
      </NavDrawer>
      <Panel>
      <EditHeader 
            review
            id={projectId}
            sku={productSku}
            brand={productBrand}
            gpuSku={gpuSku}
            segment={segment}
            partnerSiteName={partnerSite}
            risk={isRisk}
            restricted={restricted}
          />
        <div ref={this.scrollDivRef}/>
        <Card>
          <Specifications/>
        </Card>
      </Panel>
      <ActionBar
        id={id}
        onSubmit={onSubmit}
        setFormStatus={setFormStatus}
        redirect={redirect}
      />
    </Layout>
  )}
}

ReviewLayout.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

// const withStyles = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const enhance = compose(
  withConnect,
  // withStyles
)
export default enhance(ReviewLayout)
